import 'css-chunk:src/components/badge/badge-component.module.scss';export default {
  "badge-component-wrapper": "badge-component_badge-component-wrapper__dFluu",
  "badge-component": "badge-component_badge-component__1AONl",
  "small": "badge-component_small__FzJ7T",
  "medium": "badge-component_medium__rez5s",
  "large": "badge-component_large__d6QCm",
  "no-icon": "badge-component_no-icon__Axeo-",
  "yellow": "badge-component_yellow__hGoj3",
  "icon": "badge-component_icon__7smE3",
  "teal": "badge-component_teal__sSFW3",
  "green": "badge-component_green__b8-Wx",
  "mono": "badge-component_mono__koGs9",
  "purple": "badge-component_purple__JAs8B",
  "red": "badge-component_red__BzSMz",
  "icon-wrapper": "badge-component_icon-wrapper__pkpWp",
  "children": "badge-component_children__R4a9s",
  "bold": "badge-component_bold__f5V89",
  "hide-badge": "badge-component_hide-badge__pwloV",
  "on-click": "badge-component_on-click__hDK-m"
};